import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Tabs,Badge} from "antd";
const {TabPane} = Tabs;
/**
 * creat by tianruojun
 * @description tabs模板
 * @class TabsTemplate
 * @extends {Component}
 */
export default class TabsTemplate extends Component {
    static propTypes = {
        nav: PropTypes.array,
        tabChange: PropTypes.func,
        tabKey: PropTypes.string
    };
    static defaultProps = {
        nav:[],
        tabChange: ()=>{},
        tabKey: '1',
        with: 'auto'
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
        const observer = new ResizeObserver(e=>{
            e.forEach(entry=>{
                this.props.onResize(entry.target.offsetHeight);
            });
        });
        const target = document.querySelector('.TabsTemplate');
        target&&observer.observe(target)
    }


    render() {

        const {nav, styleOut} = this.props;
        let tab = '';
        if (nav?.length > 1) {
            tab = <Tabs
                key={"Tabs"}
                className={'tabs'}
                 activeKey={this.props.tabKey}
                 onChange={(tabKey) => {
                    this.props.tabChange(tabKey)
                }}
            >
                {
                    nav.map(item =>{

                          return <TabPane tab={
                            <>
                                <Badge offset={[14,-5]} count={item?.num} overflowCount={item?.overflowCount}>
                                    {item.src?<img style={{width: 16, objectFit: 'cover',marginRight:5, }} src={item.src}
                                          alt=""/>:null}
                                    <span style={{
                                        // whiteSpace: "nowrap",
                                        // width:item.width?item.width:'80px',
                                        // display:'inline-block',
                                        // overflow: "hidden",
                                        // textOverflow: 'ellipsis'
                                    }}>{item?.name}</span>
                                </Badge>
                            </>
                        } key={item?.key}/>

                    }

                    )
                }

            </Tabs>

        }
        return (
            <div className={"TabsTemplate"} style={{width:this.props.width}}>
                {tab}
                <style>{`.TabsTemplate .ant-tabs-nav-container{padding-left: ${styleOut && styleOut.paddingLeft ? styleOut.paddingLeft : 0}};`}</style>
            </div>
        )
    }

}